import { ArrowDownward } from '@mui/icons-material'
import { AccordionDetails, useMediaQuery } from '@mui/material'
import { useTranslation } from "react-i18next"
import { Accordion, AccordionSummary } from '@mui/material'
import React, { useState, useContext } from 'react'
import { BufferService, M_Button, M_Fieldset, M_InputTextField, LoadingContext, M_Select, M_DrawerTableTextField, M_TabsInpage } from 'src/M_Components'

export const Audit = () => {

    const [primaryKey, setPrimaryKey] = useState('')
    const [auditResponse, setAuditResponse] = useState([])
    const [tableSelect, setTableSelect] = useState('')
    const [subTableSelect, setSubTableSelect] = useState('')
    const [drawerValues, setDrawerValues] = useState(null)
    const [otherValues, setOtherValues] = useState(new Map())
    const [tabValue, setTabValue] = useState(0)
    const [subTableAudit, setSubTableAudit] = useState([])
    const auditService = new BufferService('audit')

    const breakAuditWidth = useMediaQuery('(min-width:800px)')

    const bookingService = new BufferService('viewbooking')
    const shipmentService = new BufferService('shipment')
    const shipmentDetailService = new BufferService('shipmentDetail')
    const bookingEquipmentService = new BufferService('bookingEquipment')
    const shipmentDangerousGoodsService = new BufferService('shipmentDangerousGoods')
    const CustomsOfficeService = new BufferService('CustomsOffice')
    const BookingEquipmentDimensionsService = new BufferService('BookingEquipmentDimensions')
    const BLService = new BufferService('BL')
    const { t } = useTranslation()

    const ctx = useContext(LoadingContext)


    const submit = () => {
        auditService.getId(primaryKey).then(res => {

            if (Array.isArray(res)) {
                setAuditResponse(res)

                if (tableSelect === 'booking') {
                    ctx.setIsLoad(true)
                    const tempArray = new Map()
                    const oldTempArray = new Map()
                    shipmentService.filter(`?filter=IdBooking eq ${primaryKey}`).then(ShipObj => {
                        ctx.setIsLoad(false)

                        tempArray.set('shipment', ShipObj)
                        tempArray.set('shipmentDetail', [])
                        tempArray.set('bookingequipment', [])
                        tempArray.set('shipmentdangerousgoods', [])
                        tempArray.set('customsOffice', [])
                        tempArray.set('bookingequipmentdimensions', [])

                        oldTempArray.set('bookingequipment', [])
                        oldTempArray.set('shipmentdangerousgoods', [])
                        oldTempArray.set('customsOffice', [])
                        // oldTempArray.set('bookingequipmentdimensions', [])


                        if (Array.isArray(ShipObj)) {
                            ShipObj.map(shipIds => {
                                shipmentDetailService.filter(`?filter=IdShipment eq ${shipIds.Id}`).then(shipDetailsObj => {

                                    tempArray.set('shipmentDetail', [...tempArray?.get('shipmentDetail'), ...shipDetailsObj.Items])
                                    if (Array.isArray(shipDetailsObj.Items)) {
                                        shipDetailsObj.Items.map(shipDetailsId => {
                                            bookingEquipmentService.filter(`?filter=Id eq ${shipDetailsId.IdBookingEquipment}`).then(bookingEquipmentObj => {

                                                const bookingArray = []
                                                bookingEquipmentObj.forEach(obj => {

                                                    if (!oldTempArray.get('bookingequipment').includes(obj.Id)) {
                                                        oldTempArray.set('bookingequipment', [...oldTempArray.get('bookingequipment'), obj.Id])
                                                        bookingArray.push(obj)
                                                    }
                                                })

                                                tempArray.set('bookingequipment', [...tempArray?.get('bookingequipment'), ...bookingArray])

                                                shipmentDangerousGoodsService.filter(`?filter=IdShipment eq ${shipIds.Id}`).then(shipmentDangerousGoods => {
                                                    const shipmentDangerousGoodsArray = []

                                                    shipmentDangerousGoods.Items.forEach(shipDangGoods => {
                                                        if (!oldTempArray.get('shipmentdangerousgoods').includes(shipDangGoods.Id)) {
                                                            oldTempArray.set('shipmentdangerousgoods', [...oldTempArray.get('shipmentdangerousgoods'), shipDangGoods.Id])
                                                            shipmentDangerousGoodsArray.push(shipDangGoods)
                                                        }
                                                    });
                                                    tempArray.set('shipmentdangerousgoods', [...tempArray?.get('shipmentdangerousgoods'), ...shipmentDangerousGoodsArray])

                                                    CustomsOfficeService.filter(`?filter=IdShipment eq ${shipIds.Id}`).then(customsOffice => {

                                                        const customsOfficeArray = []
                                                        customsOffice.Items.forEach(custOffice => {
                                                            if (!oldTempArray.get('customsOffice').includes(custOffice.Id)) {
                                                                oldTempArray.set('customsOffice', [...oldTempArray.get('customsOffice'), custOffice.Id])
                                                                customsOfficeArray.push(custOffice)
                                                            }
                                                        });
                                                        tempArray.set('customsOffice', [...tempArray?.get('customsOffice'), ...customsOfficeArray])
                                                        bookingEquipmentObj.forEach(bookEquip => {

                                                            BookingEquipmentDimensionsService.filter(`?filter=BookingEquipmentId eq ${bookEquip.Id}`).then(bookingequipmentdimensions => {
                                                               

                                                                tempArray.set('bookingequipmentdimensions', [...tempArray?.get('bookingequipmentdimensions'), ...bookingequipmentdimensions?.Items])
                                                                setOtherValues(new Map(tempArray))
                                                            })

                                                        })

                                                    })
                                                })

                                            })
                                        })
                                    }


                                })
                            })
                        }


                    })
                }
            }
        })
    }


    const auditSubTable = (tab) => {
        ctx.setIsLoad(true)
        auditService.getId(tab.obj.Id).then(res => {
            ctx.setIsLoad(false)
            if (res?.name === "AxiosError") {
                ctx.toastMessages('error', res?.message)
                setSubTableAudit([])
                return
            }
            if (res) {
                setSubTableAudit(res)
            } else {
                setSubTableAudit([])
            }
        })
    }

    const returnAudit = () => {
        if (tabValue === 0) {
            return auditResponse
        }
        if (subTableAudit) {
            return subTableAudit
        } return []
    }


    const Tables = [
        { label: 'Bookings', value: 'booking', field: 'BookingNumber' },
        { label: 'Booking Equipments', value: 'bookingequipment', field: null },
        { label: 'Shipments', value: 'shipment', field: null },
        { label: 'Shipment Details', value: 'shipmentDetail', field: null },
        { label: 'BL', value: 'bl', field: 'NrBooking' },
        { label: 'Entities', value: 'account', field: null },
        { label: 'Addresses', value: 'accountOffice', field: null },
        { label: 'Companies', value: 'company', field: null },
        { label: 'Vessel', value: 'vessel', field: null },
        { label: 'Voyages', value: 'transport', field: null }
    ]

    const BookingTable = [
        { label: 'Booking Equipments', value: 'bookingequipment' },
        { label: 'Shipments', value: 'shipment' },
        { label: 'Shipment Details', value: 'shipmentDetail' },
        { label: 'Shipment Dangerous Goods', value: 'shipmentdangerousgoods' },
        { label: 'Customs Office', value: 'customsOffice' },
        { label: 'Booking Equipment Dimensions', value: 'bookingequipmentdimensions' },
        // { label: 'BL', value: 'bl' },
    ]

    const BLTable = [
        { label: 'Booking', value: 'booking' },
        { label: 'Booking Equipments', value: 'bookingequipment' },
        { label: 'Shipments', value: 'shipment' },
        { label: 'Shipment Details', value: 'shipmentDetail' },
    ]

    return (
        <div>
            <M_Fieldset
                label={'Audit'}
                labelInside
                elements={
                    <div style={{ height: tableSelect === 'booking' || tableSelect === 'bl' ? '75vh' : '70vh', overflow: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                            <M_InputTextField
                                size={'200px'}
                                label={'Id'}
                                value={primaryKey || ''}
                                onChange={(e) => setPrimaryKey(e.target.value)}
                            />
                            <div style={{ width: '200px', margin: '10px 20px' }}>
                                <M_Select
                                    value={tableSelect}
                                    options={Tables}
                                    onChange={(e) => setTableSelect(e.target.value)}
                                />
                                {(tableSelect === 'booking' || tableSelect === 'bl') && <M_Select
                                    value={subTableSelect}
                                    options={tableSelect === 'booking' ? BookingTable : tableSelect === 'bl' ? BLTable : []}
                                    onChange={(e) => setSubTableSelect(e.target.value)}
                                />}
                            </div>
                            <div style={{ width: '200px', margin: '20px' }}>
                                <M_DrawerTableTextField
                                    entity={tableSelect}
                                    value={drawerValues}
                                    labelFields={['Id']}
                                    fieldType={'Id'}
                                    onSubmitValue={obj => {
                                        if (obj) {
                                            setDrawerValues(obj)
                                            setPrimaryKey(obj.Id)
                                        } else {
                                            setDrawerValues(null)
                                            setPrimaryKey('')
                                        }
                                    }}
                                />
                            </div>
                            <M_Button
                                bold
                                label={'Search'}
                                onClick={submit}
                            />
                        </div>

                        {tableSelect && <div>
                            <M_TabsInpage
                                firstTabOpen={tabValue}
                                onGetTab={(tab, tabObj) => {
                                    if (tabObj.value !== "key") {
                                        auditSubTable(tabObj)
                                    }
                                    setTabValue(tabObj.id)
                                }}
                                type={'tabs'}
                                renderTabs={subTableSelect && otherValues?.get(subTableSelect) ?
                                    [{ labelTab: `${tableSelect}`, value: 'key', id: 0 }, ...otherValues?.get(subTableSelect)?.map((OT, index) => {
                                        if (subTableSelect === 'bookingequipment' || subTableSelect === 'shipment') {
                                            return { labelTab: `${subTableSelect} ${OT?.TransportKey || index}`, value: index + 1, id: index + 1, obj: OT }
                                        }
                                        return { labelTab: `${subTableSelect} ${index}`, value: index + 1, id: index + 1, obj: OT }
                                    })] :
                                    [{ labelTab: `${tableSelect}`, value: 'key', id: 0 }]}
                            />
                        </div>}

                        <div style={{ width: '100%', height: '60vh', }}>
                            {returnAudit()?.sort((a, b) => Date.parse(a?.CreationDate) - Date.parse(b?.CreationDate))?.map((obj, index) => (
                                <Accordion
                                    sx={{
                                        border: '1px solid var(--color-black)',
                                        borderRadius: '10px !important',
                                        marginBottom: '20px',
                                        scrollbarWidth: '0px'
                                    }}
                                    key={index}
                                >
                                    <AccordionSummary
                                        expandIcon={<ArrowDownward />}
                                    >
                                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <div style={{ display: 'grid', gridTemplateColumns: !breakAuditWidth ? 'auto' : '33% 33% 33%', alignItems: 'center', width: '100%', marginBottom: '10px' }}>
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ fontSize: '12px', marginRight: '10px', alignItems: 'center' }}>
                                                        {t("Action")}:
                                                    </div>
                                                    <div style={{ color: obj.Action == 'Create' ? 'var(--color-green)' : obj.Action == 'Update' ? 'var(--color-yellow)' : 'var(--color-black)', fontWeight: 'bolder' }}>
                                                        {obj.Action}
                                                    </div>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                        {t("CreatedByEmail")}:
                                                    </div>
                                                    <div style={{
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'wrap'
                                                    }}>
                                                        {obj.CreatedByEmail}
                                                    </div>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                        {t("On")}:
                                                    </div>
                                                    <div >
                                                        {obj.CreationDate.replace('T', ' ').split('.')[0]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionSummary>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <div style={{
                                            width: '80%',
                                            borderBottom: `2px solid var(--color-black)`,
                                            marginBottom: '10px',
                                        }}></div>
                                    </div>
                                    {obj.AuditFields.map((objField, indexFields) => (
                                        <AccordionDetails
                                            key={indexFields}
                                            sx={{
                                                backgroundColor: indexFields % 2 && 'var(--color-grey-light)',
                                                borderBottomLeftRadius: indexFields + 1 === obj?.AuditFields?.length && '10px',
                                                borderBottomRightRadius: indexFields + 1 === obj?.AuditFields?.length && '10px'
                                            }}
                                        >
                                            <div style={{ color: 'var(--color-black)', display: 'grid', gridTemplateColumns: !breakAuditWidth ? 'auto' : '33% 33% 33%' }}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                        {t("Field")}:
                                                    </div>
                                                    <div style={{
                                                        userSelect: 'all',
                                                        fontWeight: 'bold',
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'wrap'
                                                    }}>
                                                        {objField.Field}
                                                    </div>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                        {t("OldValue")}:
                                                    </div>
                                                    <div style={{
                                                        userSelect: 'all',
                                                        fontWeight: 'bold',
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'wrap'
                                                    }}>
                                                        {objField.OldValue || 'null'}
                                                    </div>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                        {t("NewValue")}:
                                                    </div>
                                                    <div style={{
                                                        userSelect: 'all',
                                                        fontWeight: 'bold',
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'wrap'
                                                    }}>
                                                        {objField.NewValue || 'null'}
                                                    </div>
                                                </div>
                                            </div>
                                        </AccordionDetails>
                                    ))}
                                </Accordion>
                            ))
                            }
                        </div>
                    </div>
                }
            />
        </div >
    )
}
